import { useEffect, useState } from "react";
import "./precommon.css";

export default function ImageSlider({ images = [] }) {

  const [current, setCurrent] = useState(0);

  useEffect(() => {

    if (!images.length) return;

    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);

  }, [images.length]);


  const getPosition = (index) => {

    const total = images.length;

    let diff = index - current;

    if (diff < -total / 2) diff += total;
    if (diff > total / 2) diff -= total;

    switch (diff) {
      case 0:
        return "center";

      case -1:
        return "left";

      case 1:
        return "right";

      case -2:
        return "far-left";

      case 2:
        return "far-right";

      default:
        return "hidden";
    }
  };


  if (!images.length) return null;


  return (
    <>
      <div className="slider-header" data-aos="fade-up">
        <h2>A Legacy of Love</h2>
        <p>With the Blessings of Our Families</p>
      </div>

      <div className="slider-wrapper" data-aos="fade-up">

        {images.map((image, index) => (
          <div
            key={index}
            className={`slider-card ${getPosition(index)}`}
          >
            <img
              src={image.url}
              alt="cover-bottom-images"
              draggable={false}
              srcSet={`
                ${image.url.replace("/upload/", "/upload/w_320/")} 320w,
                ${image.url.replace("/upload/", "/upload/w_640/")} 640w,
                ${image.url.replace("/upload/", "/upload/w_1080/")} 1080w
              `}
              sizes="
                (max-width: 320px) 320px,
                (max-width: 640px) 640px,
                (max-width: 1080px) 1080px
              "
            />
          </div>
        ))}

      </div>
    </>
  );
}